import React, { useEffect, useState } from 'react';
import {
    Grid,
    Paper,
    Box,
    Typography,
    CircularProgress,
} from "@material-ui/core/";
import { Link } from 'react-router-dom';

import SupplierDeclarationForm, { SupplierDeclarationItem } from '../../../../forms/shared/termsDeclarations/SupplierDeclarationForm';
import FormBase from '../../../../forms/FormBase';
import Controls from '../../../../components/controls/Controls';

import TermsDeclarationsService from '../../../../services/TermsDeclarationsService';
import TermsDeclarations from '../../../../models/TermsDeclarations';
import { ModalHandle } from '../../../../components/controls/Modal';
import { ITableHeaderProps } from '../../../../components/controls/Table';
import TmpHtmlContentCustom from '../../../../components/tempo/TmpHtmlContentCustom/TmpHtmlContentCustom';

interface SupplierDeclarationProps {
    Name: string;
    Crm: string;
    Checked: boolean;
    SupplierDeclarationForm: SupplierDeclarationForm;
    onInputChange: (name: string, form: FormBase, value: any) => void;
    onInserOrUpdateSupplierItem: () => void
    onCancelEditSupplierItem: () => void
    onEditSupplierClick: (e: SupplierDeclarationItem) => void
    onDeleteSupplierClick: (e: SupplierDeclarationItem) => void
    onCheckedClick: (e: any) => void

}

export default function SupplierDeclaration(props: SupplierDeclarationProps) {


    const headers: ITableHeaderProps[] = [
        { title: "Fornecedor", align: "center", property: "SupplierName", type: "text" },
        { title: "Insumo", align: "center", property: "Input", type: "text" },
        { title: "Relação com o Fornecedor", align: "center", property: "RelationshipSupplier", type: "text" },
    ]

    const modalRef = React.createRef<ModalHandle>();

    const handleOpenModalChild = () => {
        modalRef.current?.handleOpen()
    };

    const [checkedTerm, setCheckedTerm] = useState(props.Checked);

    const [text1, setText1] = useState<string>("")
    const [text2, setText2] = useState<string>("")
    const [title, setTitle] = useState<string>("")
    const [id, setId] = useState<number>(0)

    useEffect(() => {

        TermsDeclarationsService.getCurrentTermsDeclarations("DECL_RELACAO_FORNECEDORES").then(e => {

            if (e) {
                let textTerm: string = e.description;

                var text1 = textTerm.split('#{props.Component}')[0]
                var text2 = textTerm.split('#{props.Component}')[1]

                text1 = text1.replace("#{props.Name}", props.Name)
                text1 = text1.replace("#{props.Crm}", props.Crm)

                setText1(text1)
                setText2(text2)
                setTitle(e.title)
                setId(e.textId);
            }
        })

    }, [props.Name, props.Crm])

    useEffect(() => {

        if (props.SupplierDeclarationForm.SupplierDeclarationItemList.length > 0) {
            setCheckedTerm(true)
        }

    }, [props.SupplierDeclarationForm.SupplierDeclarationItemList.length]);


    const handleCheckdTerm = (e: any) => {

        if (props.SupplierDeclarationForm.SupplierDeclarationItemList.length > 0) {
            setCheckedTerm(true)
            props.onCheckedClick(new TermsDeclarations(id, true));
        } else {

            setCheckedTerm(e.target.value);
            props.onCheckedClick(new TermsDeclarations(id, e.target.value));
        }

    }

    return (
        <Grid item xs={12} sm={12}>

            {
                id === undefined || id === 0 ?
                    <Grid container justifyContent="center" style={{ width: "85%" }} >
                        <CircularProgress />
                    </Grid>
                    :

                    <Controls.Checkbox
                        name="SupplierDeclaration"
                        labelComponent={
                            <div>
                                <span>Li e estou de acordo com a  </span>
                                <Link to={'#'} onClick={() => handleOpenModalChild()}>Declaração de Relação com Fornecedores.</Link>

                                {
                                    props.SupplierDeclarationForm.SupplierDeclarationItemList.length === 0 ?
                                        <strong>(nenhum fornecedor informado)</strong> :
                                        props.SupplierDeclarationForm.SupplierDeclarationItemList.length === 1 ?
                                            <strong>(1 fornecedor informado)</strong> :
                                            <strong>({props.SupplierDeclarationForm.SupplierDeclarationItemList.length} fornecedores informados)</strong>

                                }

                            </div>
                        }
                        value={checkedTerm}
                        onChange={handleCheckdTerm}
                    />
            }


            <Controls.Modal ref={modalRef} title={title}>

                <Typography variant="body1" gutterBottom component="div">
                    <TmpHtmlContentCustom html={text1} />
                    
                </Typography>


                <Paper elevation={3} >
                    <Box p={1}>
                        <Typography variant="overline" gutterBottom component="div">
                            Cadastrar Fornecedores:
                        </Typography>
                    </Box>
                    <Box p={1}>

                        <Grid container
                            alignItems="flex-end"
                            spacing={2}>

                            <Grid item xs={6} sm={6}>
                                <Controls.Input name="SupplierName" label="Fornecedor *" placeholder="Digite o nome do fornecedor" value={props.SupplierDeclarationForm.SupplierName.Value}
                                    onChange={(e) => {
                                        props.onInputChange("SupplierName", props.SupplierDeclarationForm, e.target.value);
                                    }}
                                    onBlur={(e) => {
                                        props.onInputChange("SupplierName", props.SupplierDeclarationForm, e.target.value);
                                    }}
                                    error={props.SupplierDeclarationForm.SupplierName.Error}
                                />
                            </Grid>

                            <Grid item xs={6} sm={6}>
                                <Controls.Input name="Input" label="Insumo *" placeholder="Digite o nome do fornecedor" value={props.SupplierDeclarationForm.Input.Value}
                                    onChange={(e) => {
                                        props.onInputChange("Input", props.SupplierDeclarationForm, e.target.value);
                                    }}
                                    onBlur={(e) => {
                                        props.onInputChange("Input", props.SupplierDeclarationForm, e.target.value);
                                    }}
                                    error={props.SupplierDeclarationForm.Input.Error}
                                />
                            </Grid>

                            <Grid item xs={8} sm={8}>
                                <Controls.Input name="RelationshipSupplier" label="Relação com o fornecedor (*)" placeholder="Digite qual é a relação com o fornecedor" value={props.SupplierDeclarationForm.RelationshipSupplier.Value}
                                    onChange={(e) => {
                                        props.onInputChange("RelationshipSupplier", props.SupplierDeclarationForm, e.target.value);
                                    }}
                                    onBlur={(e) => {
                                        props.onInputChange("RelationshipSupplier", props.SupplierDeclarationForm, e.target.value);
                                    }}
                                    error={props.SupplierDeclarationForm.RelationshipSupplier.Error}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Box style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>

                                    {(props.SupplierDeclarationForm.SupplierDeclarationItemToEdit.Id > 0 ?
                                        <Controls.Button text="Cancelar" type="Error" onClick={props.onCancelEditSupplierItem} /> : null
                                    )}

                                    {(props.SupplierDeclarationForm.SupplierDeclarationItemToEdit.Id === 0 ?
                                        <Controls.Button text="Adicionar" type="Success" onClick={props.onInserOrUpdateSupplierItem} />
                                        : <Controls.Button text="Salvar" type="Success" onClick={props.onInserOrUpdateSupplierItem} />
                                    )}

                                </Box>
                            </Grid>

                            <Grid item xs={12}>
                                <Controls.Table
                                    headers={headers}
                                    actionColumn={true}
                                    onDeleteClick={props.onDeleteSupplierClick}
                                    onEditClick={props.onEditSupplierClick}
                                    rows={props.SupplierDeclarationForm.SupplierDeclarationItemList}
                                />
                            </Grid>

                        </Grid>


                    </Box>

                    <Typography variant="body1" gutterBottom component="div">
                        <TmpHtmlContentCustom html={text2} />
                    </Typography>

                </Paper>




            </Controls.Modal>
        </Grid>
    );
}

